import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'; 
import classnames from 'classnames';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { fetchAnimalTypes } from '../../actions/addAnimalType';
import { fetchBreedTypes , deleteBreedType, updateBreedType } from '../../actions/addBreedType';
import {fetchBreedCategories , deleteBreedCategory} from '../../actions/breedCategory'
import { fetchBreeders, fetchCurrentUserForSetting } from '../../actions/breeders';
import { fetchBreedAttributes, deleteBreedAttribute  } from '../../actions/breedAttribute';
import {fetchFoodTypes , deleteFoodType} from '../../actions/foodType';
import { fetchRegTypes, getDeletable } from '../../actions/regType';
import { fetchCustomers } from '../../actions/customers';
// import '../../App.css';
import AddAnimalTypeForm from './addAnimalType';
import AddRegTypeForm from './addRegisterType';
import AddBreedTypeForm from './addBreedType';
import AddBreedCategoryForm from './addBreedCategory';
import AddBreedAttributeForm from './addBreedAttribute'
import AddBreedFoodTypeForm from './breedFoodType';
import BusinessInfoForm from './businessInfo';
import UsersList from '../../components/dataSection/dataSection';
import HowFindUs from './howFindUs';
import NewUserForm from '../../components/dataModal/dataModal';
import ContractTerms from './contractTerms';
import ChangeLog from './changeLog';
import Configuration from './configuration';
import Customers from './customers';
import Affiliates  from '../../components/veterinarian';
import BreedQuiz  from '../../components/breedQuiz';
// import './dashboard.css';
import { BreadCrumb } from '../../components/breadcrumb';
import { attachSignature } from '../../actions/breeders';
import { Loader } from '../../components/loader';
import { Activity } from '../../components/activity';
import Switch from "react-switch";
import { align } from '@progress/kendo-drawing';

const $ = window.$;
var toaOptions = {};

let SearchBarButton = (props) => {
  const { type } = props;
  return (
    <div className="m-form m-form--label-align-right m--margin-top-20 m--margin-bottom-30">
      <div className="row align-items-center">
        <div className="col-xl-8 order-2 order-xl-1">

        </div>
        <div className="col-xl-4 order-1 order-xl-2 m--align-right">
          {type === 'animal' &&
            <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill" data-toggle="modal" data-target="#add_animal_type">
              <span>
                <i className="la la-plus"></i>
                <span>
                  New Animal Type
                </span>
              </span>
            </a>
          }
          {type === 'breed' &&
            <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill" data-toggle="modal" data-target="#add_breed_type">
              <span>
                <i className="la la-plus"></i>
                <span>
                  New Breed Type
                </span>
              </span>
            </a>
          }
          {type === 'breedAttribute' &&
            <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill" data-toggle="modal" data-target="#add_breed_attribute">
              <span>
                <i className="la la-plus"></i>
                <span>
                  New Breed Attribute
                  </span>
              </span>
            </a>
          }
        {type === 'breedFoodType' &&
            <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill" data-toggle="modal" data-target="#add_breed_food">
              <span>
                <i className="la la-plus"></i>
                <span>
                  New Breed Food Type
                </span>
              </span>
            </a>
          }
          {/* {type === 'breeder' &&
            <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill" data-toggle="modal" data-target="#add_breeder">
              <span>
                <i className="la la-plus"></i>
                <span>
                  New Breeder
                </span>
              </span>
            </a>
          } */}
          {type === 'regType' &&
            <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill" data-toggle="modal" data-target="#add_reg_type">
              <span>
                <i className="la la-plus"></i>
                <span>
                  New Registration Type
                </span>
              </span>
            </a>
          }
          {type === 'breedCategory' &&
            <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill" data-toggle="modal" data-target="#add_breed_category">
              <span>
                <i className="la la-plus"></i>
                <span>
                  New Email Template
                </span>
              </span>
            </a>
          }
          <div className="m-separator m-separator--dashed d-xl-none"></div>
        </div>
      </div>
    </div>
  )
}
const { SearchBar } = Search;
class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.file = React.createRef();
    this.state = {
      user_group: "",
      viewCustomer: {},
      user: null,
      animalData: [],
      breedData: [],
      breederData: [],
      regData: [],
      breedCategoryData : [],
      breedAttributeData : [],
      foodTypeData :[],
      customerData: [],
      sort: {
        column: null,
        direction: 'desc',
      },
      selectedTab: 'Info',
      changeSignature: false,
      loadingSignature: false,
      imgSrc: '',
      imgName: '',
      imageFile: '',
      loading: false , 
      editBreedCategory : false , 
      selectedBreedCategoryData : {},
      selectedBreedAttributeData :{},
      selectedBreedData : {},
      deleteBCId : "",
      deleteBreedId : "",
      loadingDeleteBreedCategory : false ,
      loadingDeleteBreedAttribute : false,
      loadingDeleteBreed : false,
      selectedFoodTypeData :{},
      selectedRegTypeData :{},
      deleteBCId : "",
      deleteFoodTypeId : "",
      loadingDeleteBreedCategory : false ,
      loadingDeleteFoodType : false,
      loadingDeleteRegType : false,
      loadingDeleteBreedAttributeType : false,
      minimumQty : "",
      selectedBreed : "", 
      loadingBreedMinimumQuantity : false,  
    };
  }  

  tableHeaderAnimalColumnData = [
    {
      dataField: 'type', text: 'Animal Type', sort: true, filter: textFilter()
    },
    {
      dataField: 'createdAt', text: 'Created Date', formatter: cell => moment(cell).format('YYYY-MM-DD h:mm:ss a'), sort: true, filter: textFilter()
    },
    {
      dataField: 'createdBy', text: '', formatter: (cell, row) => {
        return ( 
          <Activity  row={row} created={row.createdPet} updated={row.updatedPet} deleted={row.deletedPet}/>
        );
      }, sort: true,
      headerStyle: (selector, id) => {
        return { width: "50px", textAlign: "center" };
      }
    }
  ];

  tableHeaderBreedColumnData = [
    {
      dataField: 'animal_type', text: 'Animal Type', sort: true, formatter: cell => cell,
      filter: selectFilter({
        options: toaOptions
      }),
      filterValue: (cell, row) => {
        for (let t in toaOptions) {
          if (toaOptions[t] === cell) {
            return t;
          }
        }
      }
    },
    {
      dataField: 'breed_type', text: 'Breed Type', sort: true, filter: textFilter()
    },
    {
      dataField: 'cross_breed', text: 'Cross Breed', formatter: cell => cell ? "YES" : "NO", sort: true, filter: textFilter()
    },
    {
      dataField: 'BreedCategory', text: 'Email Template', formatter: cell => cell ? cell.name : "-", sort: true, filter: textFilter()
    }, 
    {
      dataField: 'createdAt', text: 'Created Date', formatter: cell => moment(cell).format('YYYY-MM-DD h:mm:ss a'), sort: true, filter: textFilter()
    },
    {
      dataField: 'minimum_quantity', text: 'Minimum Quantity', align : "right", formatter: cell => cell ? cell : 0, sort: true,
      formatter: (cell, row) => {
        return (     
        
            <a
              href='#'
              onClick={(e) => { this.openBreedQuantityChangeModal(e,row)}}
              style={{ cursor: "pointer", color : "#5867dd", fontWeight : "600", }}
              className="text-dark"
            >
            <div>
              <span>
                <i className="la la-edit"></i>
              </span>           
              <span>
                { cell ? cell : 0 }
              </span>
            </div>            
            </a>
          
        );
      },
      headerStyle : () => {
        return { width : "100px", textAlign : "center"}
      }
    },
    {
      dataField: 'is_visible_on_breed_dashboard', text: 'Display on Dashboard', align : 'center',
       formatter: (cell, row) => {
        return ( 
          <Switch onChange={ (status) => this.handleDisplayOnDashboard(status,row)} 
            checked={cell} 
            uncheckedIcon={false} 
            checkedIcon={false}         
            onColor={"#28a745"}
            offColor={"#f4516c"}
          />
        )
       }, 
       headerStyle: () => {
        return { textAlign: "center" };
      },
    },
    {dataField : "actions" , text : "Actions"  , formatter : (cell, row) => {
      return ( 
        <div>     
        <button
         onClick={(e) => this.onBreedEditClick(e, row.id)}
          className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
          title="View"
        >
          <i className="far fa-edit"></i>
        </button>
        <button
        onClick={(e) => {          
          this.openConfirmModalBreed(e, row.id)
        }}
          className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
         >
          <i className="la la-trash-o"></i> 
        </button>
        </div>
      );
    }},
    {
      dataField: 'createdBy', text: '', formatter: (cell, row) => {
        return ( 
          <Activity  row={row} created={row.createdBreed} updated={row.updatedBreed} deleted={row.deletedBreed}/>
        );
      }, 
      sort: true,
      headerStyle: (selector, id) => {
        return { width: "50px", textAlign: "center" };
      }
    },
  ];

  expandRowBreed = {
    renderer: row => ( 
      <>
      { row.BreedAttributeLists &&  row.BreedAttributeLists.length > 0  ? <ul>            
        {row.BreedAttributeLists.map((att , index) => (                                       
              <li className="mb-2">{att.BreedAttribute.name}</li>																				
        ))}
      </ul> : <p> No Attributes Selecetd </p> }  
      </>    
    ),  
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b style={{cursor: 'pointer'}}><i className="fas fa-chevron-circle-up"></i></b>;
      }
      return <b style={{cursor: 'pointer'}}><i className="fas fa-chevron-circle-down"></i></b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return (
          <div style={{cursor: 'pointer', marginTop: '0px'}}><i className="fas fa-chevron-circle-up"></i></div>
        );
      }
      return (
        <div style={{cursor: 'pointer', marginTop: '0px'}}><i className="fas fa-chevron-circle-down"></i></div>
      );
    }
};

  tableHeaderBreedCategoryColumnData = [ 
      {dataField : "actions" , text : "Actions"  , formatter : (cell, row) => {
        return ( 
          <div>     
          <button
            onClick={(e) => this.onBreedCategoryEditClick(e, row.id)}
            className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
            title="View"
          >
                <i className="far fa-edit"></i>
          </button>
          <button
          onClick={(e) => {          
               this.openConfirmModal(e, row.id)
          }}
            className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
           >
              <i className="la la-trash-o"></i> 
          </button>
          </div>
        );
      }},
      {dataField : "email_templatename" , text : "Email Template" ,sort: true, filter: textFilter() },
      {dataField : "name" , text : "Name" ,sort: true, filter: textFilter() },
      {
        dataField: 'createdAt', text: 'Created Date', formatter: cell => moment(cell).format('YYYY-MM-DD h:mm:ss a'), sort: true, filter: textFilter()
      },
      {
        dataField: 'createdBy', text: '', formatter: (cell, row) => {
          return ( 
            <Activity  row={row} created={row.createdBreedCategory} updated={row.updatedBreedCategory} deleted={row.updatedBreedCategory}/>
          );
        }, sort: true,
        headerStyle: (selector, id) => {
          return { width: "50px", textAlign: "center" };
        }
      }
  ];

  tableHeaderBreedAttributesColumnData = [ 
    {dataField : "actions" , text : "Actions"  , formatter : (cell, row) => {
      return ( 
        <div>     
        <button
          onClick={(e) => this.onBreedAttributeEditClick(e, row.id)}
          className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
          title="View"
        >
              <i className="far fa-edit"></i>
        </button>
        {/* <button
        onClick={(e) => {          
             this.openConfirmModalBreedAttribute(e, row.id)
        }}
          className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
         >
            <i className="la la-trash-o"></i> 
        </button> */}
        </div>
      );
    }}, 
    {dataField : "name" , text : "Name" ,sort: true, filter: textFilter() },
    {dataField : "description" , text : "Description" ,sort: true, filter: textFilter() },
    {
      dataField: 'createdAt', text: 'Created Date', formatter: cell => moment(cell).format('YYYY-MM-DD h:mm:ss a'), sort: true, filter: textFilter()
    },
    {
      dataField: 'createdBy', text: '', formatter: (cell, row) => {
        return ( 
          <Activity  row={row} created={row.createdBreedAttribute} updated={row.updatedBreedAttribute} deleted={row.deletedBreedAttribute}/>

        );
      }, sort: true,
      headerStyle: (selector, id) => {
        return { width: "50px", textAlign: "center" };
      }
    }
];

//test
tableHeaderBreedFoodTypeData = [
    {dataField : "actions" , text : "Actions"  , 
    headerStyle: (column, colIndex) => {
      return { width: '100px' };
    },
    formatter : (cell, row) => {
      return ( 
        <div>     
        <button
          onClick={(e) => this.onFoodTypeEditClick(e, row.id)}
          className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
          title="View"
        >
              <i className="far fa-edit"></i>
        </button>
        <button
        onClick={(e) => {          
             this.openConfirmDeleteModalFoodType(e, row.id)
        }}
          className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
         >
            <i className="la la-trash-o"></i> 
        </button>
        </div>
      );
    }},
    {dataField : "avatar_title" , text : "Image"  , formatter : (cell, row) => {
      return (
        <span>
          <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.avatar_path + "/" + row.avatar_file_name
              }
              style={{ maxWidth: "75px", marginBottom: "5px" }}
              alt=""
          />
         </span>) 
      }},
    {dataField : "title" , text : "Title" ,sort: true,  },
    {dataField : "affiliate_link" , text : "Affiliate Link" ,sort: true,   
    headerStyle: (column, colIndex) => {
      return { width: '500px' };
    }  ,
    formatter : (cell, row) => { 
      return(
     <a className="content" target="_blank" href={cell} >{cell}</a>)
    } },
    {
      dataField: 'createdAt', text: 'Created Date', formatter: cell => moment(cell).format('YYYY-MM-DD h:mm:ss a'), sort: true, 
    },
    {
      dataField: 'createdBy', text: '', formatter: (cell, row) => {
        return ( 
          <Activity row={row} created={row.createdFoodType} updated={row.updatedFoodType} deleted={row.deletedFoodType}/>
        );
      }, sort: true,
      headerStyle: (selector, id) => {
        return { width: "50px", textAlign: "center" };
      }
    }
  ]


  tableHeaderBreederColumnData = [

    {
      dataField: "id",
      text: "Signature",
      sort: true,
      headerStyle: (column, colIndex) => {
        return { width: '220px' };
      },
      formatter: (cell, row) => {
        return (
          <span>
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.signature_path
              }
              style={{ maxWidth: "100px", marginBottom: "10px" }}
              alt=""
            />
            {this.state.changeSignature == false ?
              <div className="form-group m-form__group row">
                {/* <label className="col-lg-4 col-form-label">Select Image</label> */}
                <div className="col-lg-6">
                  <input
                    ref={this.file}
                    type="file"
                    accept="image/*"
                    name="imgName"
                    onChange={this._onChange}
                  />

                </div>
              </div>
              :
              null
            }


            <div className="m-widget4__info mx-auto my-0 mt-1 col-sm-6">
              <button onClick={() => this.saveSignature(row.id)} type="button" style={{ borderRadius: "1px", fontSize: "10px", padding: "6px" }} className="btn m-btn--pill btn-outline-primary"><i className="fas fa-cloud-upload-alt"></i> Save</button>
            </div>

          </span>
        );
      }
    },
    {
      dataField: 'breeder', text: 'Name', filter: textFilter(), sort: true,
    },
    {
      dataField: 'usda_no', text: 'USDA No', filter: textFilter(), sort: true
    },
    {
      dataField: 'addressLine1', text: 'Address Line 1', filter: textFilter(), sort: true
    },
    {
      dataField: 'addressLine2', text: 'Address Line 2', filter: textFilter(), sort: true
    },
    {
      dataField: 'addressCity', text: 'City', filter: textFilter(), sort: true
    },
    {
      dataField: 'addressState', text: 'State', filter: textFilter(), sort: true
    },
    {
      dataField: 'addressCountry', text: 'Country', filter: textFilter(), sort: true
    },
    {
      dataField: 'createdAt', text: 'Created Date', formatter: cell => moment(cell).format('YYYY-MM-DD h:mm:ss a'), sort: true, filter: textFilter()
    },
    {
      dataField: 'createdBy', text: '', formatter: (cell, row) => {
        return ( 
          <Activity row={row} created={row.createdBreeder} updated={row.updatedBreeder} deleted={row.deletedBreeder}/>
        );
      }, sort: true,
      headerStyle: (selector, id) => {
        return { width: "50px", textAlign: "center" };
      }
    }
  ];

  tableHeaderRegColumnData = [
    {dataField : "actions" , text : "Actions"  ,
    headerStyle: (column, colIndex) => {
      return { width: '100px' };
    },
     formatter : (cell, row) => {
      return ( 
        <div>     
        <button
          onClick={(e) => this.onRegTypeEditClick(e, row.id)}
          className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
          title="View"
        >
              <i className="far fa-edit"></i>
        </button>
        <button
        onClick={(e) => {          
             this.openConfirmDeleteModalRegType(e, row.id)
        }}
          className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
         >
            <i className="la la-trash-o"></i> 
        </button>
        </div>
      );
    }},
    {
      dataField: 'type', text: 'Type', filter: textFilter(), sort: true
    },
    {
      dataField: 'createdAt', text: 'Created Date', formatter: cell => moment(cell).format('YYYY-MM-DD h:mm:ss a'), sort: true, filter: textFilter()
    },
    {
      dataField: 'createdBy', text: '', formatter: (cell, row) => {
        return ( 
          <Activity row={row} created={row.createdRegistrationType} updated={row.updatedRegistrationType} deleted={row.deletedRegistrationType}/>
        );
      }, sort: true,
      headerStyle: (selector, id) => {
        return { width: "50px", textAlign: "center" };
      }
    }
  ];

  onBreedEditClick = (e, id) => {
    e.preventDefault();
    this.setState({ selectedBreedData: null }, () => {
      let selectedBreedData = _.find(this.state.breedData, { 'id': id });

      if (selectedBreedData) {
        this.setState({ selectedBreedData: selectedBreedData  });
      }
    })
  }

  clearSelectedDataToEdit = () => {
    this.setState({
      selectedBreedAttributeData :{},
      selectedBreedCategoryData :{},
      selectedFoodTypeData :{},
      selectedRegTypeData :{},
    })
  }

  handlerBreedData = () => {
    this.setState({
      selectedBreedData : {}  
    });
  }

  handlerBreedAttribute = () => {
    this.clearSelectedDataToEdit();
  }

  handlerBreedCategory = () => {
    this.clearSelectedDataToEdit();
  }

  handlerFoodType = () => {
    this.clearSelectedDataToEdit();
  }

  handlerRegType = () => {
    this.clearSelectedDataToEdit();
  }

  handleDisplayOnDashboard = (status,row) => {
    let breedData = {
      id : row.id,   
      is_visible_on_breed_dashboard : status,
    };
    const breedAttributes = row.BreedAttributeLists;
    let attributesList = [];
    for(let attribute of breedAttributes){
     let data = {
      label : attribute.BreedAttribute.name,
      value : attribute.BreedAttribute.id
     };
     attributesList.push(data);
    }
    breedData.breedAttributes = attributesList;
    this.props.updateBreedType(breedData);
  }
 
    onBreedCategoryEditClick = (e, id) => {
        e.preventDefault();
        
        this.setState({ selectedBreedCategoryData: null }, () => {
          let selectedBreedCategoryData = _.find(this.state.breedCategoryData, { 'id': id });
    
          if (selectedBreedCategoryData) {
            this.setState({ selectedBreedCategoryData: selectedBreedCategoryData  });
          }
        })
    }

    onBreedAttributeEditClick = (e, id) => {
      e.preventDefault();
      
      this.setState({ selectedBreedAttributeData: null }, () => {
        let selectedBreedAttributeData = _.find(this.state.breedAttributeData, { 'id': id });
  
        if (selectedBreedAttributeData) {
          this.setState({ selectedBreedAttributeData: selectedBreedAttributeData  });
        }
        })
      }
    onFoodTypeEditClick = (e, id) => {
      e.preventDefault();
      
      this.setState({ selectedFoodTypeData: null }, () => {
        let selectedFoodTypeData = _.find(this.state.foodTypeData, { 'id': id });
  
        if (selectedFoodTypeData) {
          this.setState({ selectedFoodTypeData: selectedFoodTypeData  });
        }
      })
  }

  onRegTypeEditClick = (e, id) => {
    e.preventDefault(); 
    this.setState({ selectedRegTypeData: null }, () => {
      let selectedRegTypeData = _.find(this.state.regData, { 'id': id });       
      if (selectedRegTypeData) {
        this.setState({ selectedRegTypeData: selectedRegTypeData  });
      }
    })
  }

      

  buttonFormatterSig(cell, row) {
    return (
      <div>
        <span className="dropdown show">
          <span className="dropdown">
            <a
              href=""
              className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i className="la la-ellipsis-h"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              <a
                className="dropdown-item"
                onClick={() => this.changeSignature()}
              >
                <i className="la la-trash-o"></i> Chnage Signature
              </a>
            </div>
          </span>
        </span>
      </div>
    );

  }

  saveSignature = async (id) => {
    let _self = this;
    this.setState({ loadingSignature: true, loading: true });
    let formData = new FormData();
    formData.append('file', this.state.imageFile);
    let result = await attachSignature(id, formData);

    result.payload.then(async resp => {
      _self.setState({ breederData: [] });

      await _self.changeSignature();

      _self.setState({ loading: false });

      NotificationManager.success("Signature Updated Successfully");

    })

    // window.location.reload();
  }

  changeSignature = () => {
    // this.setState({changeSignature: true});
    return this.props.fetchBreeders();
  }

  _onChange = (event) => {
    // Assuming only image
    event.persist();
    this.setState({ imageFile: event.target.files[0] });
    var file = event.target.files[0];
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);
    reader.onloadend = function (e) {
      this.setState({
        imgSrc: reader.result,
        imgName: file
      })
    }.bind(this);
  }   

 
  componentDidMount() {   
    this.setState({ user: this.props.user});
    this.props.fetchAnimalTypes();
    this.props.fetchBreedTypes();
    this.props.fetchBreedCategories();
    this.props.fetchBreedAttributes();
    this.props.fetchFoodTypes();
    this.props.fetchBreeders();
    this.props.fetchRegTypes();
    this.props.fetchCurrentUserForSetting(this.props.user.username);

  }

  openConfirmModal(e, bcId) {
    e.preventDefault();
    this.setState({ deleteBCId: bcId });
    $("#confirm_breed_category_delete_modal").modal("show");
  }
  
  openConfirmDeleteModalFoodType(e, foodTypeId) {
    e.preventDefault();
    this.setState({ deleteFoodTypeId: foodTypeId });
    $("#confirm_food_type_delete_modal").modal("show");
  }

  openConfirmDeleteModalRegType(e, regTypeId) {
    e.preventDefault();   
    this.setState({ deleteRegTypeId: regTypeId, selectedRegTypeData: null });
    $("#confirm_reg_type_delete_modal").modal("show");
  }

  deleteRegType(){
    this.setState({ loadingDeleteRegType: true });
    if (this.state.deleteRegTypeId) {this.props.getDeletable(this.state.deleteRegTypeId);}
    else {
      NotificationManager.warning("Invalid registration type.");
      this.setState({ loadingDeleteFoodType: false });
    }
  }


  deleteBreedCategory() {
    this.setState({ loadingDeleteBreedCategory: true });
    if (this.state.deleteBCId) {this.props.deleteBreedCategory(this.state.deleteBCId);}
    else {
      NotificationManager.warning("Invalid breed category.");
      this.setState({ loadingDelete: false });
    }
  }

  openConfirmModalBreedAttribute(e, baId){
    e.preventDefault();
    this.setState({ deleteBAId: baId });
    $("#confirm_breed_attribute_delete_modal").modal("show");
  }

  openConfirmModalBreed(e, bId){
    e.preventDefault();
    this.setState({ deleteBreedId: bId });
    $("#confirm_breed_delete_modal").modal("show");
  }

  deleteBreedAttribute() {
    this.setState({ loadingDeleteBreedAttribute: true });
    if (this.state.deleteBAId) {this.props.deleteBreedAttribute(this.state.deleteBAId);}
    else {
      NotificationManager.warning("Invalid breed attribute.");
      this.setState({ loadingDeleteBreedAttribute: false });
    }
  }

  deleteBreedType() {
    this.setState({ loadingDeleteBreed: true });
    if (this.state.deleteBreedId) {this.props.deleteBreedType(this.state.deleteBreedId);}
    else {
      NotificationManager.warning("Invalid breed.");
      this.setState({ loadingDeleteBreed: false });
    }
  }
  deleteFoodType() {
    this.setState({ loadingDeleteFoodType: true });
    if (this.state.deleteFoodTypeId) {this.props.deleteFoodType(this.state.deleteFoodTypeId);}
    else {
      NotificationManager.warning("Invalid food type.");
      this.setState({ loadingDeleteFoodType: false });
    }
  }


  componentWillReceiveProps = (nextProps) => {
    // if (nextProps.data.addAnimalTypeReducer.animalTypes !== this.props.data.addAnimalTypeReducer.animalTypes) {
    //   this.props.fetchAnimalTypes();
    // }
    if (nextProps.data.addAnimalTypeReducer.animalTypes !== this.props.data.addAnimalTypeReducer.animalTypes) {
      let i = 0;
      for (let t of nextProps.data.addAnimalTypeReducer.animalTypes) {
        toaOptions[i] = t.type;
        i++;
      }
      this.setState({ animalData: nextProps.data.addAnimalTypeReducer.animalTypes });
    }

    if (nextProps.data.addBreedTypeReducer.breedTypes !== this.props.data.addBreedTypeReducer.breedTypes) {
      nextProps.data.addBreedTypeReducer.breedTypes.forEach(u => {
        u.animal_type = u.Pet.type;
      })
      this.setState({ breedData: nextProps.data.addBreedTypeReducer.breedTypes });
    }
    if (this.props.data.breedAttributeReducer.breedAttributes !== nextProps.data.breedAttributeReducer.breedAttributes) {
      this.setState({ breedAttributeData: nextProps.data.breedAttributeReducer.breedAttributes });
    }
    if (this.props.data.breedCategoryReducer.breedCategories !== nextProps.data.breedCategoryReducer.breedCategories) {
      this.setState({ breedCategoryData: nextProps.data.breedCategoryReducer.breedCategories });
    }

    if (this.props.data.foodTypeReducer.foodTypes !== nextProps.data.foodTypeReducer.foodTypes) {
      this.setState({ foodTypeData: nextProps.data.foodTypeReducer.foodTypes });
    }

    if (nextProps.data.breederReducer.breederList !== this.props.data.breederReducer.breederList) {
      this.setState({ breederData: nextProps.data.breederReducer.breederList });
    }

    if (nextProps.data.regTypeReducer.regTypes !== this.props.data.regTypeReducer.regTypes) {
      // nextProps.data.regTypeReducer.regTypes.forEach(u => {
      //     u.createdAt = moment(u.createdAt).format('MMMM Do YYYY, h:mm:ss a');;
      // })
      this.setState({ regData: nextProps.data.regTypeReducer.regTypes });
    }

    if (this.props.data.addAnimalTypeReducer.setAnimalType !== nextProps.data.addAnimalTypeReducer.setAnimalType) {
      this.props.fetchAnimalTypes();
    }
   
    if (this.props.data.breedCategoryReducer.setBreedCategory !== nextProps.data.breedCategoryReducer.setBreedCategory) {
      this.props.fetchBreedCategories();    
    }

    if (this.props.data.foodTypeReducer.setFoodType !== nextProps.data.foodTypeReducer.setFoodType) {
      this.props.fetchFoodTypes();    
    }

    if (this.props.data.breedCategoryReducer.updateBreedCategory !== nextProps.data.breedCategoryReducer.updateBreedCategory) {
      this.props.fetchBreedCategories();    
    }

    if (this.props.data.breedAttributeReducer.setBreedAttribute  !== nextProps.data.breedAttributeReducer.setBreedAttribute) {
      this.props.fetchBreedAttributes();    
    }

    if (this.props.data.breedAttributeReducer.updateBreedAttribute !== nextProps.data.breedAttributeReducer.updateBreedAttribute) {
      this.props.fetchBreedAttributes();    
    }

    if (this.props.data.addBreedTypeReducer.updateBreedType !== nextProps.data.addBreedTypeReducer.updateBreedType) {
      this.props.fetchBreedTypes();    
      $("#edit_breed_minimum_quantity_modal").modal("hide");
      this.setState({ loadingBreedMinimumQuantity : false });
    }  
    if (this.props.data.foodTypeReducer.updateFoodType !== nextProps.data.foodTypeReducer.updateFoodType) {
      this.props.fetchFoodTypes();    
    }

    if (this.props.data.breedCategoryReducer.selectedToDelete !== nextProps.data.breedCategoryReducer.selectedToDelete) {
      this.setState({loadingDeleteBreedCategory: false});
      NotificationManager.success("Breed Category Deleted Successfully");
      this.props.fetchBreedCategories(); 
      $('#confirm_breed_category_delete_modal').modal('hide');
    }
    if (this.props.data.breedAttributeReducer.selectedToDelete !== nextProps.data.breedAttributeReducer.selectedToDelete) {
      this.setState({loadingDeleteBreedAttribute: false});
      NotificationManager.success("Breed Attribute Deleted Successfully");
      this.props.fetchBreedAttributes(); 
      $('#confirm_breed_attribute_delete_modal').modal('hide');
    }
    if (nextProps.data.addBreedTypeReducer.deleteBreedType && this.props.data.addBreedTypeReducer.deleteBreedType !== nextProps.data.addBreedTypeReducer.deleteBreedType) {
      
      const medicalRecordAvailableWithBreed = '210';

      switch(nextProps.data.addBreedTypeReducer.deleteBreedType){
         case medicalRecordAvailableWithBreed:
          NotificationManager.error("Medical record available with this breed"); 
          this.setState({loadingDeleteBreed: false});
          $('#confirm_breed_delete_modal').modal('hide');
          this.props.fetchBreedTypes();
          break; 
        
         default:
          this.setState({loadingDeleteBreed: false});
          NotificationManager.success("Breed Deleted Successfully");         
          $('#confirm_breed_delete_modal').modal('hide');
          this.props.fetchBreedTypes();
          break;
      }
    }

    if (this.props.data.foodTypeReducer.selectedToDelete !== nextProps.data.foodTypeReducer.selectedToDelete) {
      this.setState({loadingDeleteFoodType: false});
      NotificationManager.success("Food Type Deleted Successfully");
      this.props.fetchFoodTypes(); 
      $('#confirm_food_type_delete_modal').modal('hide');
    }

    if (this.props.data.regTypeReducer.selectedToDelete !== nextProps.data.regTypeReducer.selectedToDelete) {
      this.setState({loadingDeleteRegType: false, selectedRegTypeData: {}});
      NotificationManager.success("Registration Type Deleted Successfully");
      this.props.fetchRegTypes(); 
      $('#confirm_reg_type_delete_modal').modal('hide');
    }

    if (this.props.data.regTypeReducer.setRegType !== nextProps.data.regTypeReducer.setRegType) {
      this.props.fetchRegTypes();
    }
    if (this.props.data.addBreedTypeReducer.setBreedType !== nextProps.data.addBreedTypeReducer.setBreedType) {
      this.props.fetchBreedTypes();
    }
    if (this.props.data.customersReducer.customerList !== nextProps.data.customersReducer.customerList) {
      this.setState({ customerData: nextProps.data.customersReducer.customerList });
    }
    // if (nextProps.data.addAnimalTypeReducer.selectedToDelete !== this.props.data.addAnimalTypeReducer.selectedToDelete && nextProps.data.addAnimalTypeReducer.selectedToDelete > 0) {
    //   this.props.fetchAnimalTypes();
    // }

    if (this.props.data.breederReducer.newSignature !== nextProps.data.breederReducer.newSignature) {
      this.setState({ loadingSignature: false, changeSignature: false });
      NotificationManager.success("Signature Updated Successfully");
    }
    if (this.props.data.breederReducer.newSignatureError !== nextProps.data.breederReducer.newSignatureError) {
      this.setState({ loadingSignature: false, changeSignature: false });
      NotificationManager.error("Failed to update Signature.");
    }

    if(nextProps.data.regTypeReducer.selectedToDeleteError && this.props.data.regTypeReducer.selectedToDeleteError !== nextProps.data.regTypeReducer.selectedToDeleteError) {
        if(nextProps.data.regTypeReducer.selectedToDeleteError.message){
          NotificationManager.error(nextProps.data.regTypeReducer.selectedToDeleteError.message);
        }
        else{
          NotificationManager.error("Something went wrong in delete process");
        }
        this.setState({loadingDeleteRegType: false, selectedRegTypeData: {}});      
    }

    if (
      this.props.currentUser !== nextProps.currentUser &&
      nextProps.currentUser
    ) {   
      this.setState({
        user_group: nextProps.currentUser.UserPetstores[0].Role.role_name
      });
    }
 
  
}

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  changeQuantity = event => {
    let value = event.target && event.target.value ? event.target.value : 0;
    this.setState({ minimumQty: value });
  };

  openBreedQuantityChangeModal = (e,row) => {
    e.preventDefault();
    let breedData = {
      id : row.id,   
    };
    $("#edit_breed_minimum_quantity_modal").modal("show");
    const breedAttributes = row.BreedAttributeLists;
    let attributesList = [];
    for(let attribute of breedAttributes){
     let data = {
      label : attribute.BreedAttribute.name,
      value : attribute.BreedAttribute.id
     };
     attributesList.push(data);
    }
    breedData.breedAttributes = attributesList;
    this.setState({ selectedBreed : breedData, minimumQty : row.minimum_quantity  });
  }

  editMinimumQuantity = (e) => {
    e.preventDefault();
    let selectedBreedData = this.state.selectedBreed;
    selectedBreedData.minimum_quantity = this.state.minimumQty; 
    this.setState({ loadingBreedMinimumQuantity : true });
    this.props.updateBreedType(selectedBreedData);
  }

  items = [
    { title: 'Settings', to: '/settings' }
  ]

  render() {
    const { animalData, breedData, breederData, breedCategoryData , breedAttributeData, foodTypeData, selectedBreedData, selectedBreedCategoryData , selectedFoodTypeData, selectedBreedAttributeData, regData, customerData, viewCustomer, user_group, 
      selectedRegTypeData, minimumQty, loadingBreedMinimumQuantity } = this.state;
    

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Settings
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="m-portlet__body">
                  <ul className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn" role="tablist">
                    <li className="nav-item m-tabs__item">
                      <button className={classnames({ "nav-link m-tabs__link btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true, "active": this.state.selectedTab === 'Info' })} onClick={() => this.setState({ selectedTab: 'Info' })}>Business Info</button>
                    </li>
                    <li className="nav-item dropdown m-tabs__item">

                      <button className={classnames({ "nav-link m-tabs__link dropdown-toggle btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true, "active": ['Animal', 'Breed','BreedAttributes','BreedFoodTypes','BreedCategories','Breeders','RegTypes'].indexOf(this.state.selectedTab) >= 0 })} data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Pet Data</button>
                      <div className="dropdown-menu">
                        <a className={classnames({ "dropdown-item": true, "active": this.state.selectedTab === 'Animal' })} href="#" onClick={() => this.setState({ selectedTab: 'Animal' })}>Animal Types</a>
                        <div className="dropdown-divider"></div>
                        <a className={classnames({ "dropdown-item": true, "active": this.state.selectedTab === 'Breed' })} href="#" onClick={() => this.setState({ selectedTab: 'Breed' })}>Breed Types</a>
                        <div className="dropdown-divider"></div>
                        <a className={classnames({ "dropdown-item": true, "active": this.state.selectedTab === 'BreedAttributes' })} href="#" onClick={() => this.setState({ selectedTab: 'BreedAttributes' })}>Breed Attributes</a>  
                        <div className="dropdown-divider"></div>
                        <a className={classnames({ "dropdown-item": true, "active": this.state.selectedTab === 'BreedFoodTypes' })} href="#" onClick={() => this.setState({ selectedTab: 'BreedFoodTypes' })}>Breed Food Types</a>
                        <div className="dropdown-divider"></div>
                        <a className={classnames({ "dropdown-item": true, "active": this.state.selectedTab === 'BreedCategories' })} href="#" onClick={() => this.setState({ selectedTab: 'BreedCategories' })}>Email Templates</a>
                        <div className="dropdown-divider"></div>
                        <a className={classnames({ "dropdown-item": true, "active": this.state.selectedTab === 'Breeders' })} href="#" onClick={() => this.setState({ selectedTab: 'Breeders' })}>Breeders</a>
                        <div className="dropdown-divider"></div>
                        <a className={classnames({ "dropdown-item": true, "active": this.state.selectedTab === 'RegTypes' })} href="#" onClick={() => this.setState({ selectedTab: 'RegTypes' })}>Registration Types</a>
                        
                      </div>
                    </li>
                    {/* <li className="nav-item m-tabs__item">
                      <button className={classnames({"nav-link m-tabs__link btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none":true, "active":this.state.selectedTab === 'Contract'})} onClick={() => this.setState({ selectedTab: 'Contract' })}>Contract Terms</button>
                    </li> */}                 
                    { user_group === "Admin" ? (
                    <li className="nav-item m-tabs__item">
                      <button className={classnames({ "nav-link m-tabs__link btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true, "active": this.state.selectedTab === 'Users' })} onClick={() => this.setState({ selectedTab: 'Users' })}>Users</button>
                    </li>
                     ):null }
                    <li className="nav-item m-tabs__item">
                      <button className={classnames({ "nav-link m-tabs__link btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true, "active": this.state.selectedTab === 'Customers' })} onClick={() => this.setState({ selectedTab: 'Customers' })}>Customers</button>
                    </li> 
                    <li className="nav-item m-tabs__item">
                      <button className={classnames({ "nav-link m-tabs__link btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true, "active": this.state.selectedTab === 'Affiliates' })} onClick={() => this.setState({ selectedTab: 'Affiliates' })}>Affiliates</button>
                    </li>                 
                    <li className="nav-item m-tabs__item">
                      <button className={classnames({ "nav-link m-tabs__link btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true, "active": this.state.selectedTab === 'Configuration' })} onClick={() => this.setState({ selectedTab: 'Configuration' })}>Configuration</button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button className={classnames({ "nav-link m-tabs__link btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true, "active": this.state.selectedTab === 'ChangeLog' })} onClick={() => this.setState({ selectedTab: 'ChangeLog' })}>What's New</button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button className={classnames({ "nav-link m-tabs__link btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true, "active": this.state.selectedTab === 'BreedQuizMap' })} onClick={() => this.setState({ selectedTab: 'BreedQuizMap' })}>Breed Quiz Mapping</button>
                    </li>
                    {/* <li className="nav-item dropdown m-tabs__item">
                      <button className={classnames({"nav-link m-tabs__link dropdown-toggle btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none":true, "active":['HowFindUs'].indexOf(this.state.selectedTab) >= 0})} data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Configuration</button>
                      <div className="dropdown-menu">
                        <a className={classnames({"dropdown-item":true, "active":this.state.selectedTab === 'HowFindUs'})} href="#" onClick={() => this.setState({ selectedTab: 'HowFindUs' })}>How you find us</a>
                      </div>
                    </li> */}
                  </ul>
                  <div className="tab-content">
                    {this.state.selectedTab === 'Info' &&
                      <div className="tab-pane active" id="m_tabs_6_1" role="tabpanel">
                        <BusinessInfoForm />
                      </div>
                    }
                    {['Animal', 'Breed','BreedCategories', 'BreedAttributes', 'Breeders', 'RegTypes','BreedFoodTypes'].indexOf(this.state.selectedTab) >= 0 &&
                      <div className="tab-pane active" role="tabpanel">
                        <SearchBarButton type={this.state.selectedTab === 'Animal' ? 'animal' : this.state.selectedTab === 'Breed' ? 'breed' : this.state.selectedTab === 'BreedCategories' ? 'breedCategory' : this.state.selectedTab == "BreedAttributes" ? 'breedAttribute' : this.state.selectedTab === 'Breeders' ? 'breeder' : this.state.selectedTab === 'RegTypes' ? 'regType' :  this.state.selectedTab === 'BreedFoodTypes' ? 'breedFoodType' : ""} />
                        {this.state.loading ?
                          <div className="col-md-12" style={{ textAlign: 'center' }}>
                            <Loader width="100px" height="100px;" />
                          </div>
                          :
                          <ToolkitProvider
                            keyField="id"
                            data={this.state.selectedTab === 'Animal' ? animalData : this.state.selectedTab === 'Breed' ? breedData : this.state.selectedTab === 'BreedCategories' ? breedCategoryData : this.state.selectedTab === 'Breeders' ? breederData : this.state.selectedTab === 'RegTypes' ? regData : this.state.selectedTab == "BreedAttributes" ? breedAttributeData : this.state.selectedTab === 'BreedFoodTypes' ? foodTypeData :  {}}
                            columns={this.state.selectedTab === 'Animal' ? this.tableHeaderAnimalColumnData : this.state.selectedTab === 'Breed' ? this.tableHeaderBreedColumnData : this.state.selectedTab === 'BreedCategories' ? this.tableHeaderBreedCategoryColumnData : this.state.selectedTab === 'Breeders' ? this.tableHeaderBreederColumnData : this.state.selectedTab === 'RegTypes' ? this.tableHeaderRegColumnData : this.state.selectedTab == "BreedAttributes" ? this.tableHeaderBreedAttributesColumnData : this.state.selectedTab === 'BreedFoodTypes' ? this.tableHeaderBreedFoodTypeData : {}}
                            search
                            defaultSortDirection="asc"
                            hover={true}
                          >
                            {
                              props => (
                                <div>
                                  <div className='px-0 mb-4 search-bar'>
                                  <div className='col-lg-9 px-0'>
                                        <h5 className="mt-3">{this.state.selectedTab === 'Animal' ? 'Animal Types' : this.state.selectedTab === 'Breed' ? 'Breed Types' : this.state.selectedTab === 'BreedCategories' ? 'Email Templates' : this.state.selectedTab == "BreedAttributes" ? 'Breed Attributes' : this.state.selectedTab === 'Breeders' ? 'Breeders' : this.state.selectedTab === 'RegTypes' ? 'Registration Types' : this.state.selectedTab == 'BreedFoodTypes' ? 'Breed Food Types' : ''}</h5>
                                    </div>
                                    <div className='col-lg-3 px-0 inner-addon right-addon'>
                                      <i className="fas fa-search"></i>
                                      <SearchBar {...props.searchProps} />
                                    </div>
                                  </div>

                                  <BootstrapTable
                                    classes="petTable"
                                    {...props.baseProps}
                                    hover
                                    striped
                                    pagination={paginationFactory()}
                                    expandRow={this.state.selectedTab === 'Breed' ? this.expandRowBreed : {} }
                                  />
                                </div>
                              )
                            }
                          </ToolkitProvider>
                        }
                      </div>
                    }
                    {/* <div className="tab-pane" id="m_tabs_6_3" role="tabpanel">
                      <SearchBar type='breed' />
                      <BootstrapTable classes="petTable" keyField="id" columns={tableHeaderBreedColumnData} data={breedData} defaultSortDirection="asc" hover={true} pagination={ paginationFactory() } filter={ filterFactory() } />
                    </div>
                    <div className="tab-pane" id="m_tabs_6_4" role="tabpanel">
                      <SearchBar type='regType' />
                      <BootstrapTable classes="petTable" keyField="id" columns={tableHeaderRegColumnData} data={regData} defaultSortDirection="asc" hover={true} pagination={ paginationFactory() } filter={ filterFactory() } />
                    </div> */}
                    {this.state.selectedTab === 'Contract' &&
                      <div className="tab-pane active" id="m_tabs_6_5" role="tabpanel">
                        <ContractTerms />
                      </div>
                    }
                    {this.state.selectedTab === 'Users' &&
                      <div className="tab-pane active" id="m_tabs_6_6" role="tabpanel">
                        <div className="m--align-right mb-4">
                          {/* <button className="btn btn-accent m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air mr-2" data-toggle="modal" data-target="#existing_user">
                            <span>
                              <i className="la la-plus"></i>
                              <span>Existing User</span>
                            </span>
                          </button> */}
                          <button className="btn btn-accent m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air" data-toggle="modal" data-target="#new_user">
                            <span>
                              <i className="la la-plus"></i>
                              <span>New User</span>
                            </span>
                          </button>
                        </div>
                        <div className="col-md-12 m-portlet__body_grey pt-4">
                          <UsersList />
                        </div>

                      </div>
                    }
                    {this.state.selectedTab === 'HowFindUs' &&
                      <div className="tab-pane active" id="m_tabs_6_5" role="tabpanel">
                        <HowFindUs />
                      </div>
                    }
                    {this.state.selectedTab === 'Configuration' &&
                      <div className="tab-pane active" id="m_tabs_6_5" role="tabpanel">
                        <div className="col-md-12 m-portlet__body_grey pt-4">
                          <Configuration />
                        </div>
                      </div>
                    }
                    {this.state.selectedTab === '' &&
                      <div className="tab-pane active" id="m_tabs_6_1" role="tabpanel">
                        <BusinessInfoForm />
                      </div>
                    }
                    {this.state.selectedTab === 'ChangeLog' &&
                      <div className="tab-pane active" id="m_tabs_6_1" role="tabpanel">
                        <ChangeLog />
                      </div>
                    }   
                    {this.state.selectedTab === 'Customers' &&
                      <div className="tab-pane active" id="m_tabs_6_1" role="tabpanel">
                        <Customers />
                      </div>
                    }                  
                        
                    {this.state.selectedTab === 'Affiliates' &&
                      <div class="tab-pane active" id="m_tabs_6_1" role="tabpanel">
                        <Affiliates />
                      </div>
                    }    
                    {this.state.selectedTab === 'BreedQuizMap' &&
                      <div class="tab-pane active" id="m_tabs_6_1" role="tabpanel">
                        <BreedQuiz />
                      </div>
                    }          
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <NewUserForm />
        <AddAnimalTypeForm />
        <AddRegTypeForm selectedRegTypeData = {selectedRegTypeData} actionRegType={this.handlerRegType}/>      
        <AddBreedCategoryForm selectedBreedCategoryData={selectedBreedCategoryData} actionBreedCategory={this.handlerBreedCategory}/>
        <AddBreedTypeForm selectedBreedData={selectedBreedData}  actionBreed={this.handlerBreedData}/>
        <AddBreedAttributeForm selectedBreedAttributeData={selectedBreedAttributeData} actionBreedAttribute={this.handlerBreedAttribute}/>
        <AddBreedFoodTypeForm selectedFoodTypeData = {selectedFoodTypeData} actionFoodType={this.handlerFoodType}/>
        <div className="modal fade show" id="view_customer" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <form className="m-form">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel" style={{ alignSelf: 'center' }}>View Pet Customer</h5>
                  <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-xl-12">

                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">Name :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.firstname} {viewCustomer.lastname}
                        </div>

                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">Email :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.email}
                        </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">Address :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.address}
                        </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">Address(optional) :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.address_opt}
                        </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">State :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.state}
                        </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">City :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.city}
                        </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">ZIP Code :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.zip_code}
                        </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">Primary Phone :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.phone_primary}({viewCustomer.phone_primary_type})
                                </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">Secondary Phone :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.phone_secondary}({viewCustomer.phone_secondary_type})
                                </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">How find us? :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.find_us}
                        </div>
                      </div>
                      <div className="form-group m-form__group row">
                        <label className="col-4 col-form-label">Created at :</label>
                        <div className="col-8 col-form-label">
                          {moment(viewCustomer.createdAt).format('YYYY-MM-DD')}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>


               


                <div className="modal-footer">
                  <div className="row">
                  </div>
                </div>

              </form>
            </div>

          </div>
        </div>

        <div
                className="modal fade"
                id="confirm_breed_category_delete_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Confirm to delete
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to delete this email template?
                      </p>
                    </div>
                    <div className="modal-footer">
                      {this.state.loadingDeleteBreedCategory == false ? (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={() => this.deleteBreedCategory()}
                            className="btn btn-primary m-btn--pill"
                          >
                            Confirm
                          </button>
                        </div>
                      ) : (
                          <div className="center-row">
                            <Loader size={50} />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>


              <div
                className="modal fade"
                id="confirm_breed_attribute_delete_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Confirm to delete 
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to delete this breed attribute ?
                      </p>
                    </div>
                    <div className="modal-footer">
                      {this.state.loadingDeleteBreedAttribute == false ? (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={() => this.deleteBreedAttribute()}
                            className="btn btn-primary m-btn--pill"
                          >
                            Confirm
                          </button>
                        </div>
                      ) : (
                          <div className="center-row">
                            <Loader size={50} />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="confirm_food_type_delete_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Confirm to delete
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to delete this food type?
                      </p>
                    </div>
                    <div className="modal-footer">
                      {this.state.loadingDeleteFoodType == false ? (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={() => this.deleteFoodType()}
                            className="btn btn-primary m-btn--pill"
                          >
                            Confirm
                          </button>
                        </div>
                      ) : (
                          <div className="center-row">
                            <Loader size={50} />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="modal fade"
                id="confirm_reg_type_delete_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Confirm to delete
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to delete this registration type?
                      </p>
                    </div>
                    <div className="modal-footer">
                      {this.state.loadingDeleteRegType == false ? (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={() => this.deleteRegType()}
                            className="btn btn-primary m-btn--pill"
                          >
                            Confirm
                          </button>
                        </div>
                      ) : (
                          <div className="center-row">
                            <Loader size={50} />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="confirm_breed_delete_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Confirm to delete 
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to delete this breed  ?
                      </p>
                    </div>
                    <div className="modal-footer">
                      {this.state.loadingDeleteBreed == false ? (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={() => this.deleteBreedType()}
                            className="btn btn-primary m-btn--pill"
                          >
                            Confirm
                          </button>
                        </div>
                      ) : (
                          <div className="center-row">
                            <Loader size={50} />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              {/* start Breed minimum quantity edit */}
              <div
                className="modal fade"
                id="edit_breed_minimum_quantity_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="SectionSelectModalLabel"
                aria-hidden="true"             
              >
                <div className="modal-dialog modal-md" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Edit Minimum Quantity
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                    <>
                      <div className="m-form form-group m-form__group row mb-0">
                      <label className="col-lg-4 pt-3">
                        Quantity:
                      </label>
                      <div className="col-lg-8 input-group m-input-group pl-0">                 
             
                       <input
                          type="number"           
                          step={50}                            
                          value={ minimumQty > 0 ? minimumQty : ""}
                          onChange={this.changeQuantity}
                          className="form-control m-input"                                      
                          aria-describedby="basic-addon1"
                        />    
                 
                        </div>                                            
                      </div>                            	                   
	                   </>               
                    </div>
                    <div className="modal-footer">
                    { !loadingBreedMinimumQuantity ?
                        <div>                       
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={(e) => this.editMinimumQuantity(e)}
                            className="btn btn-primary m-btn--pill"
                          >
                            Submit
                          </button>              
                        </div>:
                        <div className="center-row">
                          <Loader size={50} />
                        </div>
                    }                              
                    </div>
                  </div>
                </div>
              </div>           
              {/* end price edit */}
              </div>
    )
  }  
}
const mapStateToProps = state => ({
  user: state.cognito.user,
  petShop: state.petShopReducer,
  data: state,
  currentUser: state.breederReducer.currentUser, 
});

const mapDispatchToProps = dispatch => ({
  fetchAnimalTypes: () => {
    dispatch(fetchAnimalTypes());
  },
  fetchBreedTypes: () => {
    dispatch(fetchBreedTypes());
  },
  fetchBreeders: () => {
    dispatch(fetchBreeders());
  },
  fetchBreedCategories : () => {
    dispatch(fetchBreedCategories());
  },
  fetchFoodTypes : () => {
    dispatch(fetchFoodTypes());
  },
  fetchRegTypes: () => {
    dispatch(fetchRegTypes());
  },
  fetchCustomers: () => {
    dispatch(fetchCustomers());
  },
  fetchCurrentUserForSetting: un => {
    dispatch(fetchCurrentUserForSetting(un))
  },
  deleteBreedCategory : selected =>{
    dispatch(deleteBreedCategory(selected))
  },
  fetchBreedAttributes : () => {
    dispatch(fetchBreedAttributes());
  },
  deleteBreedAttribute : selected =>{
    dispatch(deleteBreedAttribute(selected))
  },
  deleteBreedType : selected =>{
    dispatch(deleteBreedType(selected))
  },
  deleteFoodType : selected =>{
    dispatch(deleteFoodType(selected))
  },
  getDeletable : selected =>{
    dispatch(getDeletable(selected))
  },
  updateBreedType: (breed) => {
    dispatch(updateBreedType(breed));
  }
  // attachSignature: (id, img) => {
  //   dispatch(attachSignature(id, img));
  // }
});

Settings = connect(mapStateToProps, mapDispatchToProps)(Settings);

export default withRouter(Settings);